import React from 'react';
// import { useStaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import Text from '../../Text';
import Link from '../../Link';
import Image from '../../Image'; // Keep this potentially, if used elsewhere, though doesn't seem used here for the logo itself
// import Img from 'gatsby-image';
import { getLang } from '../../../utils';

// Import image paths directly
import logoSrcEn from '../../../assets/images/awaken/awaken_solutions_logo_400.png';
import logoWhiteSrcEn from '../../../assets/images/awaken/awaken_solutions_logo_white_400.png';
import logoSrcFr from '../../../assets/images/awaken/solutions_awaken_logo_400.png';
import logoWhiteSrcFr from '../../../assets/images/awaken/solutions_awaken_logo_white_400.png';

const Logo = ({
  logoWrapperStyle,
  logoStyle, // This prop seems applied to the Link wrapper, not the image itself
  titleStyle,
  withAchor,
  anchorProps,
  logoSrc, // This prop seems unused in the original logic, shadowed by fetched data
  useWhiteLogo,
  title,
  width, // Width in pixels, defaults to 200
  ...props
}) => {


  const lang = getLang();

  // Select the correct image source path based on lang and useWhiteLogo
  let selectedLogoSrc;
  if (useWhiteLogo) {
    selectedLogoSrc = lang === 'fr' ? logoWhiteSrcFr : logoWhiteSrcEn;
  } else {
    selectedLogoSrc = lang === 'fr' ? logoSrcFr : logoSrcEn;
  }

  const imgElement = selectedLogoSrc ? (
    <img
      src={selectedLogoSrc}
      alt={title}
      style={{ width: `${width || 200}px`, height: 'auto' }}
    />
  ) : (
    <Text content={title} {...titleStyle} />
  );

  return (
    <Link {...props} {...logoWrapperStyle} style={logoStyle}>
      {withAchor ? (
        <a {...anchorProps}>
          {imgElement}
        </a>
      ) : (
        imgElement
      )}
    </Link>
  );
};

Logo.propTypes = {
  logoSrc: PropTypes.string,
  title: PropTypes.string.isRequired,
  logoWrapperStyle: PropTypes.object,
  logoStyle: PropTypes.object,
  titleStyle: PropTypes.object,
  withAchor: PropTypes.bool,
  anchorProps: PropTypes.object,
  useWhiteLogo: PropTypes.bool,
  width: PropTypes.number
};

Logo.defaultProps = {
  logoWrapperStyle: {
    display: 'inline-block',
    mr: '1rem',
    'a:hover,a:focus': {
      textDecoration: 'none'
    }
  },
  titleStyle: {
    display: 'inline-block',
    fontSize: '2rem',
    lineHeight: 'inherit',
    whiteSpace: 'nowrap'
  }
};
export default Logo;
